import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { Toaster } from './components/ui/sonner'
import { AuthProvider, ThemeProvider } from './contexts'
import './index.css'

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <App />
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  // </StrictMode>,
)
